import { Group, Text } from '@mantine/core';

/** Wersja aplikacji z budowania obrazu (deploy/build-push.sh), lokalnie „lokalna”. */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || 'lokalna';

/** Stopka: producent i wersja aplikacji (w aplikacji i na stronie logowania). */
export function AppFooter() {
  return (
    <Group justify="center" gap={6} py="md" c="dimmed">
      <Text size="xs" c="dimmed">
        Producent: <b>BQool</b>
      </Text>
      <Text size="xs" c="dimmed">
        ·
      </Text>
      <Text size="xs" c="dimmed">
        wersja {APP_VERSION}
      </Text>
    </Group>
  );
}
